export default function resultTemplate(){ 
	return {
  contactInfo: {
    extraEmail: []
  },
  samtala: {
    rough: "",
    a1: [],
    a2: [],
    b1: [],
    b2: [],
    c1: [],
    c2: []
  },
  beratta: {
    rough: "",
    a1: [],
    a2: [],
    b1: [],
    b2: [],
    c1: [],
    c2: []
  },
  lyssna: {
    rough: "",
    a1: [],
    a2: [],
    b1: [],
    b2: [],
    c1: [],
    c2: []
  },
  skriva: {
    rough: "",
    a1: [],
    a2: [],
    b1: [],
    b2: [],
    c1: [],
    c2: []
  },
  lasa: {
    rough: "",
    a1: [],
    a2: [],
    b1: [],
    b2: [],
    c1: [],
    c2: []
  }
}
}
